import React from 'react';
import Embed from '../../modules/foundation/components/Embed/Embed';
import { IN_VIEWPORT_LOAD_STRATEGY } from '../../modules/foundation/components/Embed/Embed.constants';
import { EmbedLoadStrategyPropType } from '../../modules/foundation/components/Embed/Embed.types';
import { generateGoogleSearchQuery } from '../../modules/foundation/services/google-maps';
import { AddressPropType } from '../../modules/foundation/types/address';
var defaultProps = {
  businessName: '',
  loadStrategy: IN_VIEWPORT_LOAD_STRATEGY
};
export default function Map(_ref) {
  var businessName = _ref.businessName,
    address = _ref.address,
    loadStrategy = _ref.loadStrategy;
  function createMapLink() {
    var query = generateGoogleSearchQuery(businessName, address);
    var embedBase = "https://www.google.com/maps/embed/v1/place?key=".concat(process.env.GOOGLE_MAPS_API_KEY, "&q=");
    return "".concat(embedBase).concat(query);
  }
  return /*#__PURE__*/React.createElement(Embed, {
    url: createMapLink(),
    className: "map",
    loadStrategy: loadStrategy,
    icon: null
  });
}
Map.defaultProps = defaultProps;